import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {EditPage} from './pages/EditPage';
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {usePermissionsFailureGuard} from '../../hooks/usePermissionsFailureGuard.ts';
import {rbacActions} from "../../config/rbac/actions.ts";

export const ContactsLayout = () => {

    // Interim until FNP-1749: a failed check shows the error page, never a redirect.
    usePermissionsFailureGuard();

    const {allowedActions} = useVerifiedPermissions()


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes(rbacActions.ListContacts) ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes(rbacActions.GetContact) ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/contacts'/>
                    )
                }
            />
        </Routes>
    );
};
